(() => {
  async function initTeabagVariants() {
    const marker = document.querySelector('.t-teabags-product');
    if (!marker) return;

    const productInfo = document.querySelector('.product__info-container');

    if (productInfo) {
      const textBlocks = productInfo.querySelectorAll('.product__text');

      if (textBlocks[0]) {
        textBlocks[0].classList.add('t-product-eyebrow');
      }

      if (textBlocks[1]) {
        textBlocks[1].classList.add('t-product-subtitle');
      }

      const titleBlock = productInfo.querySelector('.product__title');

      if (titleBlock) {
        titleBlock.classList.add('t-product-heading');
      }
    }

    const scope =
      marker.closest('.product__info-container') ||
      marker.closest('section') ||
      document;

    /* =========================================
       PRODUCT PAGE UI
    ========================================= */

    function addProductUiStyles() {
      if (document.getElementById('t-teabags-ui-styles')) return;

      const style = document.createElement('style');
      style.id = 't-teabags-ui-styles';

      style.textContent = `
        body:has(.t-teabags-product) .product__tax {
          display: none !important;
        }

        body:has(.t-teabags-product) .price__badge-sale {
          font-size: 0 !important;
        }

        body:has(.t-teabags-product) .price__badge-sale::after {
          content: "Save";
          font-family: inherit;
          font-size: 11px;
          line-height: 1;
          font-weight: 500;
          letter-spacing: 0.02em;
        }
      `;

      document.head.appendChild(style);
    }

    addProductUiStyles();

    /* =========================================
       LOAD LIVE SHOPIFY PRODUCT DATA
    ========================================= */

    let productData;

    try {
      const productPath =
  marker.dataset.productUrl ||
  window.location.pathname.replace(/\/$/, '');

      const response = await fetch(`${productPath}.js`, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(
          `Unable to load product data: ${response.status}`
        );
      }

      productData = await response.json();
    } catch (error) {
      console.error(
        'T. Buckwheat Tea variant data could not be loaded.',
        error
      );
      return;
    }

    if (
      !productData ||
      !Array.isArray(productData.variants) ||
      !productData.variants.length
    ) {
      return;
    }

    /* =========================================
       IDENTIFY SHOPIFY OPTIONS
    ========================================= */

    const optionNames = Array.isArray(productData.options)
      ? productData.options
      : [];

    const packOptionIndex = optionNames.findIndex(option => {
      const name =
        typeof option === 'string'
          ? option
          : option?.name;

      return /pack/i.test(name || '');
    });

    const flavourOptionIndex = optionNames.findIndex(
      (_, index) => index !== packOptionIndex
    );

    if (
      packOptionIndex === -1 ||
      flavourOptionIndex === -1
    ) {
      console.warn(
        'Could not identify flavour and pack Shopify options.'
      );
      return;
    }

    function getOptionName(index) {
      const option = optionNames[index];

      return typeof option === 'string'
        ? option
        : option?.name;
    }

    const flavourOptionName = getOptionName(flavourOptionIndex);
    const packOptionName = getOptionName(packOptionIndex);

    /* =========================================
       RADIO HELPERS
    ========================================= */

    function getOptionInputs(optionName) {
      return [
        ...scope.querySelectorAll('input[type="radio"]')
      ].filter(input => {
        return (
          input.name === optionName ||
          input.name === `options[${optionName}]`
        );
      });
    }

    function getFlavourInputs() {
      return getOptionInputs(flavourOptionName);
    }

    function getPackInputs() {
      return getOptionInputs(packOptionName);
    }

    function getLabel(input) {
      if (!input?.id) return null;

      return scope.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );
    }

    function getSelectedValue(inputs) {
      const selected = inputs.find(input => input.checked);
      return selected ? selected.value : null;
    }

    function getSelectedFlavour() {
      return getSelectedValue(getFlavourInputs());
    }

    /* =========================================
       VARIANT HELPERS
    ========================================= */

    function getVariantOption(variant, optionIndex) {
      return variant.options?.[optionIndex];
    }

    function getVariant(flavour, pack) {
      return productData.variants.find(
        variant =>
          getVariantOption(
            variant,
            flavourOptionIndex
          ) === flavour &&
          getVariantOption(
            variant,
            packOptionIndex
          ) === pack
      );
    }

    function getVariantsForFlavour(flavour) {
      return productData.variants.filter(
        variant =>
          getVariantOption(
            variant,
            flavourOptionIndex
          ) === flavour
      );
    }

    function getPackNumber(value) {
      const match = String(value).match(/\d+/);
      return match ? Number(match[0]) : 0;
    }

    function getValidPackValues(flavour) {
      return getVariantsForFlavour(flavour)
        .map(variant =>
          getVariantOption(
            variant,
            packOptionIndex
          )
        )
        .filter(Boolean)
        .filter(
          (value, index, array) =>
            array.indexOf(value) === index
        )
        .sort(
          (a, b) =>
            getPackNumber(a) -
            getPackNumber(b)
        );
    }

    /* =========================================
       MONEY + SAVINGS
    ========================================= */

    function formatMoney(cents) {
      const amount = Number(cents || 0) / 100;

      const currency =
        window.Shopify?.currency?.active ||
        productData.currency ||
        'GBP';

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-GB',
          {
            style: 'currency',
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(amount);
      } catch {
        return `£${amount.toFixed(2)}`;
      }
    }

    function getSavingPercentage(variant) {
      const price = Number(variant?.price || 0);
      const compareAt = Number(
        variant?.compare_at_price || 0
      );

      if (
        !compareAt ||
        compareAt <= price
      ) {
        return null;
      }

      return Math.round(
        ((compareAt - price) / compareAt) * 100
      );
    }

    /* =========================================
       MIXED PACK SUBTEXT
    ========================================= */

function getPackSubtext(
  flavour,
  pack
) {

  const packCount =
    getPackNumber(
      pack
    );


  /* Mixed Original + Peach packs */

  if (
    flavour &&
    flavour.includes('+')
  ) {

    const flavourParts =
      flavour
        .split('+')
        .map(
          part =>
            part.trim()
        )
        .filter(Boolean);


    if (
      flavourParts.length === 2 &&
      packCount &&
      packCount % 2 === 0
    ) {

      const each =
        packCount / 2;


      return `${each} ${flavourParts[0]} + ${each} ${flavourParts[1]}`;
    }


    return '';
  }


  /* Single Original or Peach pack */

  if (
    packCount === 1
  ) {

    return '15 teabags · 45 servings';
  }


  return '';
}

    /* =========================================
       PACK LABELS
    ========================================= */

    function renderPackLabel(input, flavour) {
      const label = getLabel(input);
      if (!label) return;

      const variant = getVariant(
        flavour,
        input.value
      );

      if (!variant) return;

      const saving = getSavingPercentage(variant);
      const subtext = getPackSubtext(
        flavour,
        input.value
      );

      label.innerHTML = `
        <span class="t-pack-main">
          <span class="t-pack-name">
            ${input.value}
          </span>

          <span class="t-pack-right">
            ${
              saving
                ? `
                  <span class="t-save-badge">
                    Save ${saving}%
                  </span>
                `
                : ''
            }

            <span class="t-pack-price">
              ${formatMoney(variant.price)}
            </span>
          </span>
        </span>

        ${
          subtext
            ? `
              <span class="t-pack-subtext">
                ${subtext}
              </span>
            `
            : ''
        }
      `;

      input.disabled =
        variant.available === false;

      label.classList.toggle(
        't-pack-sold-out',
        variant.available === false
      );
    }

    /* =========================================
       PACK DRAWER
    ========================================= */

    function getPackGroup() {
      const packInputs = getPackInputs();

      if (!packInputs.length) {
        return null;
      }

      return packInputs[0].closest(
        '.product-form__input'
      );
    }

    function createPackDrawer() {
      const packGroup = getPackGroup();
      const packInputs = getPackInputs();

      if (
        !packGroup ||
        !packInputs.length
      ) {
        return null;
      }

      let drawer = packGroup.querySelector(
        '.t-pack-drawer'
      );

      if (drawer) {
        return drawer;
      }

      drawer = document.createElement('div');
      drawer.className = 't-pack-drawer';

      packGroup.insertBefore(
        drawer,
        packInputs[0]
      );

      packInputs.forEach(input => {
        const label = getLabel(input);

        drawer.appendChild(input);

        if (label) {
          drawer.appendChild(label);
        }
      });

      return drawer;
    }

    function getPackDrawer() {
      return (
        getPackGroup()?.querySelector(
          '.t-pack-drawer'
        ) ||
        createPackDrawer()
      );
    }

    /* =========================================
       MORE / LESS OPTIONS
    ========================================= */

    let packsExpanded = false;
    let packAnimating = false;

    const isFeaturedProduct =
  marker.dataset.featuredProduct === 'true';

const PEEK_HEIGHT =
  isFeaturedProduct
    ? 0
    : 32;

    function getPackToggle() {
      return getPackGroup()?.querySelector(
        '.t-more-packs'
      );
    }

    function createPackToggle() {
      const packGroup = getPackGroup();
      const drawer = getPackDrawer();

      if (
        !packGroup ||
        !drawer
      ) {
        return null;
      }

      let button = getPackToggle();

      if (button) {
        return button;
      }

      button = document.createElement('button');
      button.type = 'button';
      button.className = 't-more-packs';
      button.textContent = 'More options';

      drawer.insertAdjacentElement(
        'afterend',
        button
      );

      button.addEventListener('click', () => {
        if (packAnimating) return;

        if (packsExpanded) {
          closePackDrawer();
        } else {
          openPackDrawer();
        }
      });

      return button;
    }

    function updatePackToggle(validPacks) {
      const button = createPackToggle();

      if (!button) return;

      button.style.display =
        validPacks.length > 2
          ? ''
          : 'none';

      button.classList.toggle(
        'is-open',
        packsExpanded
      );

      button.textContent =
        packsExpanded
          ? 'Less options'
          : 'More options';
    }

    /* =========================================
       COLLAPSED HEIGHT WITH REAL CARD PEEK
    ========================================= */

    function getCollapsedPackHeight(flavour) {
      const drawer = getPackDrawer();
      if (!drawer) return null;

      const validPacks =
        getValidPackValues(flavour);

      if (validPacks.length <= 2) {
        return drawer.scrollHeight;
      }

      const packInputs = getPackInputs();

      const thirdInput = packInputs.find(
        input =>
          input.value === validPacks[2]
      );

      const thirdLabel = getLabel(thirdInput);

      if (!thirdLabel) {
        return null;
      }

      const drawerRect =
        drawer.getBoundingClientRect();

      const thirdRect =
        thirdLabel.getBoundingClientRect();

      return (
        thirdRect.top -
        drawerRect.top +
        PEEK_HEIGHT
      );
    }

    function setCollapsedPackHeight(flavour) {
      const drawer = getPackDrawer();
      if (!drawer) return;

      const validPacks =
        getValidPackValues(flavour);

      if (validPacks.length <= 2) {
        drawer.style.height = 'auto';
        drawer.style.overflow = 'hidden';
        return;
      }

      const collapsedHeight =
        getCollapsedPackHeight(flavour);

      if (collapsedHeight === null) {
        return;
      }

      drawer.style.height =
        `${collapsedHeight}px`;

      drawer.style.overflow = 'hidden';
    }

    /* =========================================
       PACK LAYOUT
    ========================================= */

    function applyPackLayout(flavour) {
      const packInputs = getPackInputs();
      const drawer = getPackDrawer();

      if (!drawer) return;

      const validPacks =
        getValidPackValues(flavour);

      const orderedInputs = [
        ...packInputs
      ].sort(
        (a, b) =>
          getPackNumber(a.value) -
          getPackNumber(b.value)
      );

      /*
        Keep every valid real option rendered.
        The drawer height creates the peek.
      */

      orderedInputs.forEach(input => {
        const label = getLabel(input);

        if (!label) return;

        const valid =
          validPacks.includes(input.value);

        input.style.display =
          valid ? '' : 'none';

        label.style.display =
          valid ? '' : 'none';

        if (valid) {
          renderPackLabel(
            input,
            flavour
          );
        }

        drawer.appendChild(input);
        drawer.appendChild(label);
      });

      updatePackToggle(validPacks);

      if (
        packsExpanded ||
        validPacks.length <= 2
      ) {
        drawer.style.height = 'auto';
        drawer.style.overflow = 'hidden';
      } else {
        requestAnimationFrame(() => {
          setCollapsedPackHeight(flavour);
        });
      }
    }

    /* =========================================
       OPEN DRAWER
    ========================================= */

    function openPackDrawer() {
      const flavour =
        getSelectedFlavour();

      if (!flavour) return;

      const drawer = getPackDrawer();
      const button = getPackToggle();

      if (!drawer) return;

      packAnimating = true;

      const startHeight =
        drawer.getBoundingClientRect().height;

      packsExpanded = true;

      drawer.style.height = 'auto';

      const endHeight = drawer.scrollHeight;

      drawer.style.height =
        `${startHeight}px`;

      drawer.style.overflow = 'hidden';

      drawer.style.transition =
        'height 420ms cubic-bezier(0.22, 1, 0.36, 1)';

      drawer.offsetHeight;

      requestAnimationFrame(() => {
        drawer.style.height =
          `${endHeight}px`;
      });

      if (button) {
        button.classList.add('is-open');
        button.textContent =
          'Less options';
      }

      setTimeout(() => {
        drawer.style.height = 'auto';
        drawer.style.overflow = 'hidden';
        drawer.style.transition = '';
        packAnimating = false;
      }, 430);
    }

    /* =========================================
       CLOSE DRAWER
    ========================================= */

    function closePackDrawer() {
      const flavour =
        getSelectedFlavour();

      if (!flavour) return;

      const drawer = getPackDrawer();
      const button = getPackToggle();

      if (!drawer) return;

      packAnimating = true;

      const startHeight =
        drawer.getBoundingClientRect().height;

      const endHeight =
        getCollapsedPackHeight(flavour);

      if (endHeight === null) {
        packAnimating = false;
        return;
      }

      drawer.style.height =
        `${startHeight}px`;

      drawer.style.overflow = 'hidden';

      drawer.style.transition =
        'height 420ms cubic-bezier(0.22, 1, 0.36, 1)';

      drawer.offsetHeight;

      requestAnimationFrame(() => {
        drawer.style.height =
          `${endHeight}px`;
      });

      if (button) {
        button.classList.remove('is-open');
        button.textContent =
          'More options';
      }

      setTimeout(() => {
        packsExpanded = false;

        drawer.style.height =
          `${endHeight}px`;

        drawer.style.overflow = 'hidden';
        drawer.style.transition = '';

        packAnimating = false;
      }, 430);
    }

    /* =========================================
       UPDATE PACK OPTIONS
    ========================================= */

    function updatePackOptions(
      options = {}
    ) {
      const {
        resetExpansion = false,
        allowSelectedExpansion = false,
        forceFirstPack = false
      } = options;

      const flavour =
        getSelectedFlavour();

      if (!flavour) return;

      const validPacks =
        getValidPackValues(flavour);

      const packInputs =
        getPackInputs();

      if (
        !validPacks.length ||
        !packInputs.length
      ) {
        return;
      }

      if (resetExpansion) {
        packsExpanded = false;
      }

      let selectedPackInput =
        packInputs.find(
          input => input.checked
        );

      const firstAvailablePack =
        validPacks.find(pack => {
          const variant =
            getVariant(
              flavour,
              pack
            );

          return (
            variant &&
            variant.available !== false
          );
        });

      const firstValidPack =
        firstAvailablePack ||
        validPacks[0];

      const firstValidInput =
        packInputs.find(
          input =>
            input.value ===
            firstValidPack
        );

      /*
        Changing flavour resets to
        the first available pack.
      */

      if (
        forceFirstPack &&
        firstValidInput &&
        !firstValidInput.checked
      ) {
        firstValidInput.click();

        selectedPackInput =
          firstValidInput;
      }

      const selectedVariant =
        selectedPackInput
          ? getVariant(
              flavour,
              selectedPackInput.value
            )
          : null;

      /*
        Fallback for an invalid or
        unavailable selection.
      */

      if (
        !selectedVariant ||
        selectedVariant.available === false
      ) {
        if (
          firstValidInput &&
          !firstValidInput.checked
        ) {
          firstValidInput.click();

          selectedPackInput =
            firstValidInput;
        }
      }

      /*
        If the page initially loads
        on a pack after the first two,
        keep that selected pack visible.
      */

      if (
        allowSelectedExpansion &&
        selectedPackInput &&
        validPacks.indexOf(
          selectedPackInput.value
        ) > 1
      ) {
        packsExpanded = true;
      }

      applyPackLayout(flavour);
    }

    /* =========================================
       ADD TO CART STABILITY
    ========================================= */

    function keepAddToCartStable() {
      const button = scope.querySelector(
        '.product-form__submit'
      );

      if (!button) return;

      button.classList.add(
        't-variant-updating'
      );

      clearTimeout(
        button._tVariantUpdateTimer
      );

      button._tVariantUpdateTimer =
        setTimeout(() => {
          button.classList.remove(
            't-variant-updating'
          );
        }, 600);
    }

    /* =========================================
       FLAVOUR SELECTOR IMAGES
    ========================================= */

    function decorateFlavourLabels() {
      const script =
        document.querySelector(
          'script[src*="t-product-variants.js"]'
        );

      if (!script) return;

      const flavourImages = {
        'Original':
          script.dataset.flavourOriginal,

        'Peach':
          script.dataset.flavourPeach,

        'Original + Peach':
          script.dataset.flavourMixed
      };

      getFlavourInputs().forEach(input => {
        const label = getLabel(input);

        const image =
          flavourImages[input.value];

        if (
          !label ||
          !image
        ) {
          return;
        }

        let icon =
          label.querySelector(
            '.t-flavour-icon'
          );

        if (!icon) {
          icon =
            document.createElement('img');

          icon.className =
            't-flavour-icon';

          icon.alt = '';

          icon.setAttribute(
            'aria-hidden',
            'true'
          );

          label.prepend(icon);
        }

        icon.src = image;
      });
    }

    function initialiseFlavourIcons() {
      decorateFlavourLabels();

      let attempts = 0;

      const iconTimer =
        setInterval(() => {
          decorateFlavourLabels();

          attempts += 1;

          if (attempts >= 20) {
            clearInterval(iconTimer);
          }
        }, 100);
    }

    /* =========================================
       CONTAIN GALLERY SCROLL
    ========================================= */

    const nativeScrollIntoView =
      Element.prototype.scrollIntoView;

    let restoreGalleryScrollTimer =
      null;

    function containGalleryScroll() {
      if (restoreGalleryScrollTimer) {
        clearTimeout(
          restoreGalleryScrollTimer
        );
      }

      Element.prototype.scrollIntoView =
        function (...args) {
          const mediaItem =
            this.matches?.(
              '.product__media-item'
            )
              ? this
              : this.closest?.(
                  '.product__media-item'
                );

          const mediaGallery =
            this.matches?.(
              'media-gallery'
            )
              ? this
              : this.closest?.(
                  'media-gallery'
                );

          if (
            mediaItem ||
            mediaGallery
          ) {
            const item =
              mediaItem ||
              mediaGallery
                ?.querySelector(
                  '.product__media-item.is-active'
                );

            const mediaList =
              item?.closest(
                '.product__media-list'
              );

            if (
              item &&
              mediaList
            ) {
              mediaList.scrollTo({
                left:
                  item.offsetLeft -
                  mediaList.offsetLeft,
                behavior: 'auto'
              });
            }

            return;
          }

          return nativeScrollIntoView.apply(
            this,
            args
          );
        };

      restoreGalleryScrollTimer =
        setTimeout(() => {
          Element.prototype.scrollIntoView =
            nativeScrollIntoView;

          restoreGalleryScrollTimer =
            null;
        }, 800);
    }

    /* =========================================
       PRODUCT GALLERY IMAGE CONTROL
    ========================================= */

    function setGalleryMedia(mediaId) {
      if (!mediaId) return;

const galleryScope =
  marker.closest('.shopify-section') ||
  document;

const gallery =
  galleryScope.querySelector('media-gallery');

      if (!gallery) return;

      const sectionId =
        gallery.id?.replace(
          'MediaGallery-',
          ''
        );

      if (!sectionId) return;

      containGalleryScroll();

      if (
        typeof gallery.setActiveMedia ===
        'function'
      ) {
        gallery.setActiveMedia(
          `${sectionId}-${mediaId}`,
          false
        );
      }
    }

    function showFlavourVariantImage(
      flavour
    ) {
      if (!flavour) return;

      const variants =
        getVariantsForFlavour(flavour);

      const variant =
        variants.find(
          item =>
            item.available !== false &&
            (
              item.featured_media?.id ||
              item.featured_image?.id
            )
        ) ||
        variants.find(
          item =>
            item.featured_media?.id ||
            item.featured_image?.id
        );

      if (!variant) return;

      const mediaId =
        variant.featured_media?.id ||
        variant.featured_image?.id;

      setGalleryMedia(mediaId);
    }

    /* =========================================
       FLAVOUR CLICK → SHOW FLAVOUR IMAGE
       Works even when already selected
    ========================================= */

    scope.addEventListener(
      'click',
      event => {
        const label =
          event.target.closest?.('label');

        if (!label) return;

        const flavourInput =
          getFlavourInputs().find(
            input =>
              input.id &&
              label.htmlFor === input.id
          );

        if (!flavourInput) return;

        setTimeout(() => {
          showFlavourVariantImage(
            flavourInput.value
          );
        }, 80);
      }
    );
/* =========================================
   PRESELECT VALID PACK BEFORE SHOPIFY UPDATES
   Prevents brief "Unavailable" flash
========================================= */

function preselectValidPackForFlavour(
  flavour
) {

  if (!flavour) {
    return;
  }

  const validPacks =
    getValidPackValues(
      flavour
    );

  const packInputs =
    getPackInputs();

  if (
    !validPacks.length ||
    !packInputs.length
  ) {
    return;
  }

  const firstAvailablePack =
    validPacks.find(
      pack => {

        const variant =
          getVariant(
            flavour,
            pack
          );

        return (
          variant &&
          variant.available !== false
        );
      }
    ) ||
    validPacks[0];


  const firstValidInput =
    packInputs.find(
      input =>
        input.value ===
        firstAvailablePack
    );


  if (
    firstValidInput &&
    !firstValidInput.checked
  ) {

    /*
      Set this BEFORE Shopify handles
      the flavour change.

      Do not click it here — Shopify's
      flavour change event will read the
      newly checked pack itself.
    */

    firstValidInput.checked =
      true;
  }
}


/*
  Capture phase runs before Sense's
  normal variant-change handler.
*/

scope.addEventListener(
  'change',
  event => {

    if (
      !(
        event.target instanceof
        HTMLInputElement
      )
    ) {
      return;
    }


    const flavourInputs =
      getFlavourInputs();


    if (
      !flavourInputs.includes(
        event.target
      )
    ) {
      return;
    }


    preselectValidPackForFlavour(
      event.target.value
    );

  },
  true
);
    /* =========================================
       VARIANT CHANGES
    ========================================= */

    scope.addEventListener(
      'change',
      event => {
        if (
          !(
            event.target instanceof
            HTMLInputElement
          )
        ) {
          return;
        }

        const flavourInputs =
          getFlavourInputs();

        const packInputs =
          getPackInputs();

        const isFlavour =
          flavourInputs.includes(
            event.target
          );

        const isPack =
          packInputs.includes(
            event.target
          );

        if (
          !isFlavour &&
          !isPack
        ) {
          return;
        }

        containGalleryScroll();
        keepAddToCartStable();

        requestAnimationFrame(
          decorateFlavourLabels
        );

        if (isFlavour) {
          setTimeout(() => {
            packsExpanded = false;

            updatePackOptions({
              resetExpansion: true,
              forceFirstPack: true
            });
          }, 50);

          setTimeout(() => {
            updatePackOptions({
              resetExpansion: true,
              forceFirstPack: true
            });
          }, 200);
        }
      }
    );

    /* =========================================
       RESIZE
    ========================================= */

    window.addEventListener(
      'resize',
      () => {
        const flavour =
          getSelectedFlavour();

        if (
          !flavour ||
          packsExpanded
        ) {
          return;
        }

        requestAnimationFrame(() => {
          setCollapsedPackHeight(
            flavour
          );
        });
      }
    );

    /* =========================================
       INITIALISE
    ========================================= */

    createPackDrawer();
    createPackToggle();
    initialiseFlavourIcons();

    updatePackOptions({
      allowSelectedExpansion: true
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initTeabagVariants
    );
  } else {
    initTeabagVariants();
  }
})();